import { SelfServeNode, SelfServeNodeLevels } from "../types";
import { buildNodeLevelPropName } from "../utils/buildNodeLevelPropName";
import { getSelectedNodesFromLocalStorage } from "../utils/localStorage";

import { useSelfServeContextStore } from "./SelfServeContext";
import {
  LevelToNode,
  useNodesFromLocalStorage,
} from "./useNodesFromLocalStorage";

interface SelectedNodes {
  level0Node?: SelfServeNode;
  level1Node?: SelfServeNode;
  level2Node?: SelfServeNode;
  level3Node?: SelfServeNode;
  level4Node?: SelfServeNode;
  level5Node?: SelfServeNode;
}

export const useSelectedNode = (): SelectedNodes => {
  const nodesListFromContextStore = useNodesListFromContextStore();
  const nodesFromStorage: LevelToNode = useNodesFromLocalStorage(
    getSelectedNodesFromLocalStorage()
  );

  const selectedNodes = {} as SelectedNodes;
  for (const level of SelfServeNodeLevels) {
    const nodeLevelProp = buildNodeLevelPropName(level) as keyof SelectedNodes;
    const levelIndex = level - 1;
    if (nodesListFromContextStore[levelIndex]) {
      selectedNodes[nodeLevelProp] = nodesListFromContextStore[levelIndex];
    } else if (nodesFromStorage) {
      selectedNodes[nodeLevelProp] = nodesFromStorage[level];
    }
  }
  return selectedNodes;
};

const useNodesListFromContextStore = () => {
  const [{ level1Node, level2Node, level3Node, level4Node, level5Node }] =
    useSelfServeContextStore([
      "level1Node",
      "level2Node",
      "level3Node",
      "level4Node",
      "level5Node",
    ]);
  return [level1Node, level2Node, level3Node, level4Node, level5Node];
};
